export enum UserProperties {
  FIRST_NAME = 'fistName',
  LAST_NAME = 'lastName',
  PHONE_NUMBER = 'phoneNumber',
  EMAIL = 'email',
  POSITION = 'position',
  ID_NUMBER = 'idNumber',
  PARTNER_PROPERTY_ID = 'partnerPropertyId',
}
